/**
 * Skeleton loader components for dashboard loading states
 */

export function SkeletonCard({ className = '' }: { className?: string }) {
  return (
    <div
      className={`rounded-lg border border-border bg-wt-bg-secondary p-6 animate-pulse ${className}`}
    >
      <div className="h-4 bg-wt-bg-tertiary rounded w-1/4 mb-4"></div>
      <div className="h-8 bg-wt-bg-tertiary rounded w-1/2 mb-2"></div>
      <div className="h-3 bg-wt-bg-tertiary rounded w-3/4"></div>
    </div>
  );
}

export function SkeletonChart({ className = '' }: { className?: string }) {
  return (
    <div
      className={`rounded-lg border border-border bg-wt-bg-secondary p-6 animate-pulse ${className}`}
    >
      <div className="flex justify-between items-center mb-6">
        <div className="h-3 bg-wt-bg-tertiary rounded w-32"></div>
        <div className="flex gap-2">
          <div className="h-8 bg-wt-bg-tertiary rounded w-16"></div>
          <div className="h-8 bg-wt-bg-tertiary rounded w-16"></div>
        </div>
      </div>
      <div className="h-[400px] bg-wt-bg-tertiary rounded"></div>
    </div>
  );
}

export function SkeletonEnergyPosition() {
  return (
    <div className="rounded-lg border border-border bg-wt-bg-secondary p-6 w-full max-w-[360px] animate-pulse">
      <div className="mb-5">
        <div className="h-3 bg-wt-bg-tertiary rounded w-32 mb-3"></div>
        <div className="h-9 bg-wt-bg-tertiary rounded w-40 mb-3"></div>
        <div className="h-1.5 bg-wt-bg-tertiary rounded w-full mb-4"></div>
        <div className="space-y-2">
          <div className="h-4 bg-wt-bg-tertiary rounded w-full"></div>
          <div className="h-4 bg-wt-bg-tertiary rounded w-3/4"></div>
        </div>
      </div>
      <div className="h-px bg-border my-5"></div>
      <div className="mb-5">
        <div className="h-3 bg-wt-bg-tertiary rounded w-24 mb-2"></div>
        <div className="h-7 bg-wt-bg-tertiary rounded w-24"></div>
      </div>
      <div className="h-px bg-border my-5"></div>
      <div className="mb-5">
        <div className="h-3 bg-wt-bg-tertiary rounded w-20 mb-2"></div>
        <div className="h-6 bg-wt-bg-tertiary rounded w-20"></div>
      </div>
      <div className="h-20 bg-wt-bg-tertiary rounded-lg mt-5"></div>
    </div>
  );
}

export function SkeletonEnergyFlow() {
  return (
    <div className="rounded-lg border border-border bg-wt-bg-secondary p-5 w-full max-w-[450px] animate-pulse">
      <div className="flex justify-between items-center mb-4">
        <div className="h-3 bg-wt-bg-tertiary rounded w-24"></div>
        <div className="h-5 bg-wt-bg-tertiary rounded w-16"></div>
      </div>
      <div className="flex items-center justify-center gap-16 mb-3">
        <div className="flex flex-col items-center gap-2">
          <div className="w-10 h-10 bg-wt-bg-tertiary rounded-full"></div>
          <div className="h-3 bg-wt-bg-tertiary rounded w-12"></div>
          <div className="h-4 bg-wt-bg-tertiary rounded w-16"></div>
        </div>
        <div className="h-1 w-10 bg-wt-bg-tertiary"></div>
        <div className="flex flex-col items-center gap-2">
          <div className="w-10 h-10 bg-wt-bg-tertiary rounded-full"></div>
          <div className="h-3 bg-wt-bg-tertiary rounded w-16"></div>
          <div className="h-4 bg-wt-bg-tertiary rounded w-20"></div>
        </div>
        <div className="h-1 w-10 bg-wt-bg-tertiary"></div>
        <div className="flex flex-col items-center gap-2">
          <div className="w-10 h-10 bg-wt-bg-tertiary rounded-full"></div>
          <div className="h-3 bg-wt-bg-tertiary rounded w-12"></div>
          <div className="h-4 bg-wt-bg-tertiary rounded w-16"></div>
        </div>
      </div>
      <div className="flex gap-4 pt-3 border-t border-border">
        <div className="h-4 bg-wt-bg-tertiary rounded w-24"></div>
        <div className="h-4 bg-wt-bg-tertiary rounded w-20"></div>
      </div>
    </div>
  );
}
